<div class="forecast-chart-container">
  <div class="title header-3">
    <span>Forecast Horizon</span>
  </div>
  <div class="chart-holder">
    <app-chart-plotter
      *ngIf="chartDataToUse.ticker !== ''"
      [chartType]="chartType"
      [dataToUse]="chartDataToUse"
    ></app-chart-plotter>
  </div>
</div>
